/* UsageTableComponent.js */

"use strict";

const DataTableComponent = require("./DataTableComponent");
const { numberFormatter, dateFormatter } = require("./cellFormatters");

class UsageTableComponent extends DataTableComponent {
    _getColumns() {
        let width = 237;
        return [
            {
                id: "licenseType",
                name: "Solution",
                field: "licenseType",
                toolTip: "Application in Gluware you are licensed to use",
                width: width
            },
            {
                id: "assigned",
                name: "Licenses Assigned",
                field: "inUseLicenses",
                toolTip: "Number of licenses you currently have utilized",
                formatter: withErrorPrechecked(deviceAssigned),
                cssClass: "centered",
                headerCssClass: "centered",
                width: width
            },
            {
                id: "available",
                name: "Licenses Available",
                //field: "availableLicenses",
                field: "totalLicenses",
                toolTip: "Remaining number of licenses available to use",
                formatter: withErrorPrechecked(availableFormatter, "No Active License"),
                asyncPostRender: addErrorsTooltip,
                cssClass: "centered",
                headerCssClass: "centered",
                width: width
            },
            {
                id: "expireData",
                name: "Expiration Date",
                field: "expireDate",
                toolTip: "Date license expires at 11:59:59 PM UTC",
                formatter: withErrorPrechecked(dateFormatter),
                cssClass: "centered",
                headerCssClass: "centered",
                width: width
            },
            {
                id: "left",
                name: "Days Left",
                field: "expireDate",
                toolTip: "Number of days before the license expires",
                formatter: withErrorPrechecked(daysLeftFormatter),
                cssClass: "centered",
                headerCssClass: "centered",
                width: width
            }
        ];
    }
}

const NO_LICENSE_CODE = "NoValidLicense";
const BEFORE_LICENSE_ERROR_CODE = "BeforeActiveLicense";
const EXPIRED_LICENSE_ERROR_CODE = "LicenseExpired";

const unavailableCodes = [NO_LICENSE_CODE, BEFORE_LICENSE_ERROR_CODE, EXPIRED_LICENSE_ERROR_CODE];
function deviceAssigned(row, cell, inUseLicenses, columnDef, dataContext) {
    const totalLicenses = dataContext.totalLicenses;
    if (!Number.isFinite(+totalLicenses) && totalLicenses !== "Unlimited") {
        inUseLicenses = "";
    }
    return numberFormatter(row, cell, inUseLicenses, columnDef, dataContext);
}

function availableFormatter(row, cell, totalLicenses, columnDef, dataContext) {
    if (totalLicenses === "Unlimited") {
        return totalLicenses;
    }
    const available = totalLicenses - dataContext.inUseLicenses;
    return numberFormatter(row, cell, available, columnDef, dataContext);
}

function daysLeftFormatter(row, cell, value, columnDef, dataContext) {
    value = Math.floor((value - Date.now()) / (1e3 * 60 * 60 * 24));
    return isNaN(value) ? "" : numberFormatter(row, cell, value, columnDef, dataContext);
}

function withErrorPrechecked(formatter, onErrorValue = "") {
    return (row, cell, value, columnDef, dataContext) => {
        const { errorCode } = parseError(dataContext.error);
        return unavailableCodes.includes(errorCode)
            ? onErrorValue
            : formatter(row, cell, value, columnDef, dataContext);
    };
}

//consider to refactor it!
function parseError(errorString) {
    const errorMatches = String(errorString).match(/(\w+) - (.+)/) || [];
    return {
        errorCode: errorMatches[1],
        errorMsg: errorMatches[2]
    };
}
function addErrorsTooltip(cellNode, row, dataContext /*, colDef*/) {
    const { errorMsg } = parseError(dataContext.error);
    if (errorMsg) {
        cellNode[0].setAttribute("title", errorMsg);
    }
}
module.exports = UsageTableComponent;
